import React, { ReactElement } from 'react';
import GridContainer from 'adapter/in/dashboards/containers/Grid';
import AddFirstWidgetResultContainer from 'adapter/in/dashboards/containers/EditDashboard/AddFirstWidgetResult';
import withLoading from 'adapter/in/common/hoc/withLoading';

type EditLayoutPageProps = {
    editLayoutMode: boolean;
    hasWidgets: boolean;
    id: string;
};

const EditLayoutPage = (props: EditLayoutPageProps): ReactElement => {
    const { editLayoutMode, hasWidgets, id } = props;

    return hasWidgets ? <GridContainer dashboardId={id} isEditEnabled editingLayout={editLayoutMode} /> : <AddFirstWidgetResultContainer />;
};

export default withLoading(EditLayoutPage);
